import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-share",
  "use": "icon-share-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-share\">\r\n<path d=\"M6 17C6.56792 14.2251 7.89808 11.6634 9.84115 9.60248C11.7842 7.5416 14.2633 6.06311 17 5.333V2L24 8.637L17 15.337V12C14.9272 12.0661 12.888 12.5419 11 13.4001C9.11207 14.2582 7.41271 15.4817 6 17ZM18 17.145V20H2V8H8.6C9.3176 7.26399 10.1005 6.59458 10.939 6H0V22H20V15.231L18 17.145Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol